import { useEffect, useState } from 'react';

const MOUNT_BATCH_SIZE = 3;
const MOUNT_BATCH_DELAY_MS = 32;

type QueueEntry = {
  id: number;
  onReady: () => void;
};

let nextId = 0;
let pending: QueueEntry[] = [];
let flushTimer: number | null = null;

const flushQueue = () => {
  flushTimer = null;
  const batch = pending.splice(0, MOUNT_BATCH_SIZE);
  batch.forEach((entry) => entry.onReady());
  if (pending.length > 0) {
    flushTimer = window.setTimeout(flushQueue, MOUNT_BATCH_DELAY_MS);
  }
};

const enqueuePreviewBoardMount = (onReady: () => void): (() => void) => {
  const id = nextId++;
  pending.push({ id, onReady });
  if (flushTimer === null) {
    flushTimer = window.setTimeout(flushQueue, 0);
  }

  return () => {
    pending = pending.filter((entry) => entry.id !== id);
    if (pending.length === 0 && flushTimer !== null) {
      window.clearTimeout(flushTimer);
      flushTimer = null;
    }
  };
};

/** Spread heavy preview-board mounts across idle frames so list pages stay responsive. */
export const useQueuedPreviewMount = (enabled: boolean): boolean => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled || ready) {
      return;
    }

    return enqueuePreviewBoardMount(() => setReady(true));
  }, [enabled, ready]);

  return ready;
};
